import { FormBase } from 'core/components';
import _ from 'lodash';

export default class StepFormBase extends FormBase {
	constructor(hooks) {
		super(hooks);
	}

	getMergedForm(forms) {
		let fields = [];
		let mergedForm = {};
		forms.forEach(form => {
			fields = _.concat(fields, form.fields);
			delete form.fields;
			mergedForm = _.merge(mergedForm, form);
		});

		mergedForm.fields = fields;
		return mergedForm;
	}

	getValuesFromSteps() {
		var obj = new Object();
		_.each(this.form.values(), function(step) {
			_.merge(obj, step);
		});
		return obj;
	}
}



// WEBPACK FOOTER //
// ./src/core/components/forms/base/StepFormBase.js